import { render, staticRenderFns } from "./PromiseCardWin.vue?vue&type=template&id=b1429b22&"
import script from "./PromiseCardWin.vue?vue&type=script&lang=js&"
export * from "./PromiseCardWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports